module.exports = __webpack_public_path__ + "img/enrique-suarez.fac44288.jpg";